import React, { FC } from 'react';
import { AppendState } from 'src/components/BundleProduct/feature/bundle.register';
import { AppendState as AppendCartState } from 'src/core/state/cart';
import { DataStatus } from 'src/core/engine/types';
import { shallowEqual, useSelector } from 'react-redux';
import { BundleHeader } from 'src/components/BundleProduct/BundleHeader';
import { useVatCausesRender } from 'src/components/AppShell/VatProvider';
import { BaseProduct } from 'src/components/ProductDetail/utils/product-detail.types';
import { gtmAddToCartWithVersion } from 'src/features/analytics/epics/gtmAddToCartWithVersion';
import { AddBundleVersion } from 'src/features/analytics/utils/eventTypes';
import { ArtworkPriceBreakProps, ContextType } from 'src/components/BundleProduct/BundleOptionsProvider';

import { BundleForm } from './Bundle.form';
import classes from './BundleProductContent.scss';
import { FormData, BundleConfig } from './types';

const selector = (s: AppendState<AppendCartState>) => {
    const itemIds = s.bundle?.itemIds || [];
    return {
        messages: s.bundle?.messages || [],
        status: s.bundle?.status || DataStatus.Idle,
        cartItems: s.cart.items.filter((item) => itemIds.indexOf(item.id) > -1),
    };
};

type Props = Pick<ContextType, 'bundlePrice'> & {
    product: BaseProduct;
    bundles: BundleConfig[];
    artworkPriceBreak?: ArtworkPriceBreakProps;
    maxCustomisations: number;
    onSubmit(values: FormData): void;
    customisationOption: string;
};

export const BundleProductContent: FC<Props> = ({
    product,
    bundles,
    bundlePrice,
    artworkPriceBreak,
    maxCustomisations,
    onSubmit,
    customisationOption,
}) => {
    const state = useSelector(selector, shallowEqual);
    const basketLoading = state.status === 'Pending' || state.status === 'Success';

    if (state.status === 'Success') {
        gtmAddToCartWithVersion(AddBundleVersion.V1, product, '/basket', { price: bundlePrice });
        setTimeout(() => {
            location.href = '/basket';
        }, 1000);
    }

    const { vat } = useVatCausesRender();

    return (
        <div className={classes.wrapper}>
            <BundleHeader product={product} />
            <div className={classes.content}>
                <BundleForm
                    bundles={bundles}
                    product={product}
                    bundlePrice={bundlePrice}
                    onSubmit={onSubmit}
                    vat={vat}
                    basketLoading={basketLoading}
                    artworkPriceBreak={artworkPriceBreak}
                    maxCustomisations={maxCustomisations}
                    customisationOption={customisationOption}
                />
            </div>
        </div>
    );
};
